import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { saveByteArray } from "src/util/saveByteArray";

enum SpecialProjectReportServiceEnum {
  getBCheckReport = "/bcheck?idSpecialProject=",
  getTradeControll = "/trade-controll?idSpecialProject=",
  downloadRepriceReport = "/download-reprice-report/"
}

export default class SpecialProjectReportService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/special-project/report");
  }

  public getBCheckReport = async (idSpecialProject: number, specialProjectName?: string) => {
    const data = await this.GET(`${SpecialProjectReportServiceEnum.getBCheckReport}${idSpecialProject}`, "blob");
    const filename = `bcheck_${specialProjectName}.zip`;
    saveByteArray(filename, data);
    return data;
  };

  public getTradeControll = async (idSpecialProject: number, specialProjectName?: string) => {
    const data = await this.GET(`${SpecialProjectReportServiceEnum.getTradeControll}${idSpecialProject}`, "blob");
    const filename = `trades_${specialProjectName}.xlsx`;
    saveByteArray(filename, data);
    return data;
  };

  public downloadRepriceReport = async (idSpecialProject: number, specialProjectName?: string) => {
    const data = await this.GET(`${SpecialProjectReportServiceEnum.downloadRepriceReport}${idSpecialProject}`, "blob");
    const filename = `trades_${specialProjectName}.xlsx`;
    saveByteArray(filename, data);
    return data;
  };
}
